import * as moment from 'moment';

import { InputOption } from "../../classes/index";
import { ExtendedActionType } from "./index";

export function changeToGrid() {
    return {
        type: ExtendedActionType.GoToGridView
    }
}

export function changeToList() {
    return {
        type: ExtendedActionType.GoToListView
    }
}

export function setLastDateToDisplay(numberOfMonths: number) {
    let actualNum = numberOfMonths - 1;

    if (numberOfMonths <= 0) {
        actualNum = 1;
    }

    const lastMonth = moment().add(actualNum, "months").endOf("month");

    return {
        type: ExtendedActionType.SetLastMonthToDisplay,
        value: lastMonth
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/redux/actions/calendar-mode-actions.ts